import { render, staticRenderFns } from "./AcaoObjetoSqlEditor.vue?vue&type=template&id=03f19cf2&scoped=true"
import script from "./AcaoObjetoSqlEditor.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoSqlEditor.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoSqlEditor.vue?vue&type=style&index=0&id=03f19cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f19cf2",
  null
  
)

export default component.exports